/*
This file should be included before all other GBE js file libraries such as
gbe.gec.common.js
gbe.gec.pools.js
etc.
*/

if (com === null || typeof (com) != "object") { var com = {}; }
if (com.globalbettingexchange === null || typeof (com.globalbettingexchange) != "object") { com.globalbettingexchange = {}; }
if (com.globalbettingexchange.base === null || typeof (com.globalbettingexchange.base) != "object") { com.globalbettingexchange.base = {}; }

// all the functions in the com.gbeFragment namespace will go in this block
com.globalbettingexchange.base = {
    //wrapper method used for backward  compatibility.
    //if no local storage then use cookies. cookies are prefixed with gep_

    inArray: function (value, array) {
        if (!array) {
            return -1;
        }
        return array.indexOf(value);
    },

    trimString: function (str) {
        if (!str) {
            return "";
        }
        return str.trim();
    },
    clone: function(obj) {
        if (Object.prototype.toString.apply(obj) === '[object Array]') {
            return obj.slice();
        }

        var cloned = {};
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
              cloned[prop] = obj[prop];
            }
        }

        return cloned;
    },
    extend: function(obj1, obj2) {
        var result = {};
        for (var key in obj1) {
            if (obj1.hasOwnProperty(key)) {
            result[key] = obj1[key];
            }
        }
        for (var key in obj2) {
            if (obj2.hasOwnProperty(key)) {
            result[key] = obj2[key];
            }
        }
        return result;
    },
    localStorage: {
        "set": function (name, value) {
            if (com.globalbettingexchange.base.supportLS) {
                localStorage[name] = value;
            } else {
                com.globalbettingexchange.base.setCookie(name, value, 365);
            }
        },
        "get": function (name) {
            if (com.globalbettingexchange.base.supportLS) {
                return localStorage[name];
            } else {
                return com.globalbettingexchange.base.getCookie(name);
            }
        }
    },
    createUUID: function () {
        // Function found here: https://gist.github.com/jed/982883

        var a = "";

        function b(a) {

            // Need to create variables x and y to keep JSLint happy
            var x = a ^ Math.random() * 16 >> a / 4;
            var y = [1e7] + -1e3 + -4e3 + -8e3 + -1e11;

            return a
                ? (x).toString(16)
                : (y).replace(/[018]/g, b);
        }
        return b(a);
    },
    log: function (data, e) {
        e = (e != null) ? ":" + e : "";

        if (typeof console === "undefined" || typeof console.log === "undefined") {
            window.status = data + e;
        } else {

            console.log(data + e);
        }
    },

    // Returns HTML markup containing formatted amounts within <span> with appropriate class
    // depending on whether number of positive/negative/neutral
    GBEFormatter: function (state) {

        var currentState = state;

        /**
         * Format the specified amount as currency
         * @param {Number} amt
         * @param {Number} decimals (optional) if === 0, show no decimal places,
         *                                       otherwise always show 2 decimal places
         * @param {boolean} showCommas (optional) if true, show commas for thousands
         * @param {Number} max (optional) if true, if amt exceeds max, return max instead
         * @return {String} formatted string
         */
        this.formatCurrency = function (amt, decimals, showCommas, max) {
            var num = (isNaN(max)) ? amt : Math.min(max, amt);
            return this.formatDecimal(num, decimals, showCommas);
        }

        /**
         * Format the specified amount as a number (with no currency symbol)
         * @param {Number} amt
         * @param {Number} decimals (optional) if === 0, show no decimal places,
         *                                       otherwise always show 2 decimal places
         * @param {boolean} showCommas (optional) if true, show commas for thousands
         * @return {String} formatted string
         */
        this.formatNumber = function (amt, decimals, showCommas) {
            var currencySymbol = '';
            var formattedAmount = com.globalbettingexchange.base.formatDecimal(amt, decimals, currencySymbol, showCommas);
            var className = (amt == 0) ? 'gep-neutral' : ((amt < 0) ? 'gep-negative' : 'gep-positive');
            return String.format("<span class='{0}'>{1}</span>", className, formattedAmount);
        }

        /**
         * Format the specified amount as a number, with parentheses when negative (with no currency symbol)
         * @param {Number} amt
         * @param {Number} decimals (optional) if === 0, show no decimal places,
         *                                       otherwise always show 2 decimal places
         * @param {boolean} showCommas (optional) if true, show commas for thousands
         * @return {String} formatted string
         */
        this.formatNumberParentheses = function (amt, decimals, showCommas) {
            var currencySymbol = '';
            var formattedAmount = com.globalbettingexchange.base.formatDecimal(amt, decimals, currencySymbol, showCommas);
            var className = (amt == 0) ? 'gep-neutral' : ((amt < 0) ? 'gep-negative' : 'gep-positive');
            formattedAmount = amt < 0 ? '(' + formattedAmount.substring(1) + ')' : formattedAmount;
            return String.format("<span class='{0}'>{1}</span>", className, formattedAmount);
        }

        /**
         * Format the specified amount as currency
         * @param {Number} amt
         * @param {Number} decimals (optional) if === 0, show no decimal places,
         *                                       otherwise always show 2 decimal places
         * @param {boolean} showCommas (optional) if true, show commas for thousands
         * @return {String} formatted string
         */
        this.formatDecimal = function (amt, decimals, showCommas) {
            var currencySymbol = currentState.ccSymbol;
            var formattedAmount = com.globalbettingexchange.base.formatDecimal(amt, decimals, currencySymbol, showCommas);
            var className = (amt == 0) ? 'gep-neutral' : ((amt < 0) ? 'gep-negative' : 'gep-positive');
            return String.format("<span class='{0}'>{1}</span>", className, formattedAmount);
        }
    },

    OddsLadder: function (prices) {
        var tolerancePercent = 0.0001;   //   (= .01%)

        // Reset odds ladder and recreate hash indexes of prices
        function _reIndex(newprices, that) {
            that.priceArray = newprices;
            that.hashPriceArray = {};
            that.hashRepresentationArray = {};
            for (var i = 0; i < that.priceArray.length; i++) {
                that.hashPriceArray[that.priceArray[i].price] = that.priceArray[i];
                that.hashRepresentationArray[that.priceArray[i].representation] = that.priceArray[i];
            }
        }

        this.priceArray = prices;   // Array of prices on odds ladder
        this.hashPriceArray = {};   // Array of prices, indexed by decimal price
        this.hashRepresentationArray = {};  // Array of prices, indexed by respresentation
        this.hashArray = [{ p: 2, r: 4 }, { p: 2, r: 4 }, { p: 2, r: 4 }, { p: 2, r: 4 }];   // NOT USED - CAN BE REMOVED?!

        this.getPercentage = function (representation, format) {
            var result = 0;
            if (format === 3) {
                representation = parseFloat(representation);
                if (representation > 0) {
                    result = 100 / (1 * representation + 100);
                } else {
                    result = (-1 * representation) / (-1 * representation + 100);
                }
            } else if (format === 2) {
                var arr = representation.split("/");
                var num1 = arr[0] * 1;
                var num2 = arr[1] * 1;
                result = num2 / (num1 + num2);
            } else {
                result = 1 / (1 * representation);
            }
            result = (((result * 100).toFixed(2)) * 1).toString() + "%";
            return result;
        }

        // Return the N'th price in the ladder
        this.getItem = function (i) {
            return this.priceArray[i];
        };

        // Recreate hash indexes of prices, given the supplied odds ladder
        this.reIndex = function (newprices) {
            _reIndex(newprices, this);
        };

        // Band the specified decimal price to the equivalent price on the odds ladder (decimal/fractional/american)
        this.band = function (

            decimalPrice,   // decimal price to be banded

            direction,      // (optional) direction to go on ladder when looking for match
            // -1 for BACK bet, +1 for LAY bet
            // To step to the next odds: -2 for BACK, -2 for LAY
            // If not supplied, then we return nearest matching odds on the ladder

            showRelative,   // (optional) if true, show odds as relative to a point on the odds ladder,
            // e.g. >3/1, <5/2
            // Only applies to Fractional/American odds. If odds ladder is Decimal, a
            // value of true is ignored.

            isMultiple,     // (optional) if true, odds are for a Multiple bet. If odds ladder is decimal,
            // don't band the odds, and instead return a price object containing the
            // supplied odds (rounded to 2 decimal places)

            mustBand        // (optional) if NOT set to true, and odds ladder is decimal, then
            // decimal odds can be returned "as is", without banding to the decimal ladder
        ) {
            var above, below, delta, nextItem;


            // If its exactly on price ladder, then return price from hash (indexed) table
            if (this.hashPriceArray[decimalPrice] != null) return this.hashPriceArray[decimalPrice];

            var isDecimal = (this.priceArray[0].representation == "1.01");  // Does the table map to decimal (rather than fractional) notation?

            if (isMultiple) {
                if (isDecimal) {    // Don't use the odds ladder for decimal multiples bets - just format the amount to 2 dec. places
                    var multipleDecimal = com.globalbettingexchange.base.formatDecimal(decimalPrice, 2, '', false);
                    return { price: decimalPrice, representation: com.globalbettingexchange.base.removeTrailingZeros(multipleDecimal) + "" };
                }
            }
            if (mustBand == null) mustBand = false;         // Default
            if (isDecimal)
                showRelative = false;                       // 'showRelative' only applies when mapping to fractional odds
            if (decimalPrice == 0) return { price: 0, representation: '' };


            // if (direction == null) direction = 1;
            /*
            * We no longer set a default for direction.  If this function is called with
            * direction = null (or 0) then we let the function select the nearest matching
            * odds in the ladder. (This is how the Betdaq site behaves in Bet History, etc.)
            * If showRelative is true then we return either a '<' or a '>' symbol to show
            * that the true odds are less than or greater than the value being returned.
            *
            */
            var high = this.priceArray.length - 1;
            var low = 0;
            var mid = 0;

            while (low <= high) {
                mid = parseInt((low + high) / 2);
                delta = this.priceArray[mid].price - decimalPrice;

                if (Math.abs(delta) <= (this.priceArray[mid].price * tolerancePercent)) {


                    if ((direction != -2)               // If we were called from the step function then we do
                        && (direction != 2)) {             // not want to find a match here. Instead we want to step
                        return this.priceArray[mid];    // forward/backward to the next/previous value in the ladder
                    }
                    else {
                        break;
                    }

                } else {
                    if (delta > 0) {
                        high = mid - 1;
                    }
                    else if (delta < 0) {
                        low = mid + 1;
                    }
                    else {
                        return this.priceArray[mid];
                    }
                }

            }

            if (!mustBand && isDecimal) {
                var offLadderDecimal = com.globalbettingexchange.base.formatDecimal(decimalPrice, 2, '', false);
                return { price: decimalPrice, representation: com.globalbettingexchange.base.removeTrailingZeros(offLadderDecimal) + "" };
            }

            if ((direction == -2) || (direction == 2)) {//only if not stepping(function below) using wheel or arrows, these would be +2 -2,
                direction = direction / 2;
            }

            if (direction) {         // If specified and non-zero then value of direction is either +1 or -1
                if ((direction == -1) && (decimalPrice < this.priceArray[mid].price)) {
                    nextItem = mid + direction;
                } else if ((direction == 1) && (decimalPrice > this.priceArray[mid].price)) {
                    nextItem = mid + direction;
                } else {
                    nextItem = mid;
                }
                nextItem = (nextItem < this.priceArray.length) ? nextItem : this.priceArray.length - 1;
                nextItem = (nextItem < 0) ? 0 : nextItem;

                if (showRelative) {
                    return { price: this.priceArray[nextItem].price, representation: '>' + this.priceArray[nextItem].representation }
                }
                else {                      //  Don't say whether it's greater or less than our Best Found
                    return this.priceArray[nextItem];
                }
            }
            else {                   // No direction specified - choose whichever is nearer (above or below)
                if (decimalPrice > this.priceArray[mid].price) {    // Our search item is located between the closest match...
                    below = mid;                                    // ... and the array entry above it
                    above = mid + 1;
                    if (above > this.priceArray.length - 1) {
                        above = this.priceArray.length - 1;
                        below = this.priceArray.length - 2;
                    }
                }
                else {
                    below = mid - 1;                                // ... and the array entry below it
                    above = mid;
                    if (below < 0) {
                        below = 0;
                        above = 1;
                    }
                }

                if (Math.abs(decimalPrice - this.priceArray[below].price) < Math.abs(this.priceArray[above].price - decimalPrice)) {
                    // It's closer to the item below it.  Return this amount as our Best Found...
                    if (showRelative) {         //  ... and say it's greater than this amount
                        return { price: this.priceArray[mid].price, representation: '>' + this.priceArray[below].representation };
                    }
                    else {                      //  ... we don't want to say whether it's greater or less than our Best Found
                        return this.priceArray[mid];
                    }
                }
                else {
                    // It's closer to the item above it.  Return this amount as our Best Found...
                    if (showRelative) {         //  ... and say it's less than this amount
                        return { price: this.priceArray[above].price, representation: '<' + this.priceArray[above].representation };
                    }
                    else {                      //  ... we don't want to say whether it's greater or less than our Best Found
                        return this.priceArray[mid + 1];
                    }
                }
            }

        };

        // Return the odds ladder
        this.returnPriceArray = function () {
            return this.priceArray;
        }

        this.step = function (decimalPrice, direction) {
            decimalPrice = decimalPrice * (1 + (.00000001 * direction));
            direction = (direction) * 2;

            return this.band(decimalPrice, direction, false, false, true);
        };

        // Get the entry on the odds ladder corresponding to the given representation
        // Returns undefined if no corresponding entry.
        this.getFromRepresentation = function (representation) {
            return this.hashRepresentationArray[representation];
        };

        this.getFromDecimal = function (decimalValue) {
            if (this.hashPriceArray[decimalValue] != null)
                return this.hashPriceArray[decimalValue];
            else {
                return { price: 0, representation: "" };
            }
        };
        _reIndex(prices, this);
        return this;

    },
    formatDecimal: function (number, places, currencySymbol, showCommas) {

        var showZeros = (currencySymbol != null);
        if (currencySymbol == null) currencySymbol = '';
        if ((isNaN(number) || number == "") && (!showZeros)) {
            if (places == 0)
                return "";
            else
                return currencySymbol + "0.00";
        }

        //round to 2 decimal places
        number = Math.round(number * 100) / 100;

        //convert to string and add trailing zeroes if required
        var numberStr = (showCommas == true) ? com.globalbettingexchange.base.addCommas(number.toString()) : number.toString();
        var decimalIndex = numberStr.indexOf(".");

        if (decimalIndex == -1) { numberStr += ".00"; }
        //only one decimal place, add trailing 0
        else if ((numberStr.length - 2) == decimalIndex) { numberStr += "0"; }

        if (currencySymbol != null) {
            // Insert currency symbol, after "-" if amount is negative
            if (numberStr.substring(0, 1) == "-")
                numberStr = "-" + currencySymbol + numberStr.substring(1);
            else
                numberStr = currencySymbol + numberStr;
        }
        if (places == 0)
            numberStr = numberStr.split('.')[0];
        return numberStr;
    },
    removeTrailingZeros: function (x) {
        var decPos = x.indexOf(".")
        if (decPos > -1) {
            first = x.substring(0, decPos);
            second = x.substring(decPos, x.length);
            while (second.charAt(second.length - 1) == "0")
                second = second.substring(0, second.length - 1);
            if (second.length > 1)
                return first + second;
            else
                return first;
        }
        return x;
    },

    // Return just the name of the function passed in
    getFunctionName: function (funct) {

        var ownName = funct.toString();
        ownName = ownName.substr('function '.length);        // trim off "function "
        ownName = ownName.substr(0, ownName.indexOf('('));        // trim off everything after the function name
        return ownName;
    },

    // Takes a number in the form of a string (with or without decimal places)
    // and inserts commas for thousands
    addCommas: function (numberStr) {
        numberStr += '';
        var x = numberStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    },
    parseFromSelectionBlurb: function (itemName, blurb) {
        // Parse the selected item value from the selection blurb
        // Blurb format is "name=value~name=value~name=value"

        var value = "";

        if (blurb != null) {
            var namePosition = blurb.indexOf(itemName + "=");
            if (namePosition > -1) {
                var valuePosition = namePosition + itemName.length + 1;
                var value = blurb.substring(valuePosition);
                var endValuePosition = value.indexOf("~");
                if (endValuePosition > -1) {
                    value = value.substring(0, endValuePosition);
                }
            }
        }

        return value;
    },

    /***********************
    preventBubble stops the click on price bubbling up to parent elements
    ************************/
    preventBubble: function (e) {
        if (!e) var e = window.event;
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();
    },

    // Returns the currency symbol for a given 3-letter currency code
    getCurrencySymbol: function (code, symbol) {
		if (symbol === undefined) {
			symbol = false;
		}
        var currencySymbol = "";
        switch (code) {
            case 'AUD': currencySymbol = "$"; break;
            case 'CAD': currencySymbol = "$"; break;
            case 'CEU': currencySymbol = ""; break;
            case 'CNY': currencySymbol = "Y"; break;
            case 'EUR': currencySymbol = symbol ? "€" : "&euro;"; break;
            case 'GBP': currencySymbol = symbol ? "£" : "&pound;"; break;
            case 'HKD': currencySymbol = "$"; break;
            case 'INR': currencySymbol = symbol ? "₹" : "&#x20B9;"; break;
            case 'MYR': currencySymbol = "MYR"; break;
            case 'PEU': currencySymbol = symbol ? "€" : "&euro;"; break;
            case 'PGB': currencySymbol = symbol ? "£" : "&pound;"; break;
            case 'PHP': currencySymbol = "P"; break;
            case 'PIN': currencySymbol = "R"; break;
            case 'PUS': currencySymbol = "$"; break;
            case 'RMB': currencySymbol = "RMB"; break;
            case 'RUB': currencySymbol = ""; break;
            case 'SGD': currencySymbol = "$"; break;
            case 'TWD': currencySymbol = "$"; break;
            case 'UAH': currencySymbol = ""; break;
            case 'USD': currencySymbol = "$"; break;
            case 'THB': currencySymbol = "THB"; break;
        }
        return currencySymbol;
    },

    // Only called from Exchange.Tablet - remove from base?
    getMinimumStake: function (code) {
        var minimumStakes = { EUR: .5, GBP: .5, INR: 50, USD: 1, RMB: 1, SGD: 1, MYR: 1, VND: 1000, THB: 50, IDR: 1000, KRW: 1000, HKD: 5 };
        return minimumStakes[code] || 1;
    },

    // Accesses global variable - remove or rewrite?!
    minimumStake: function () {//probably obsolete
        return clientObject.minimumStakes[clientObject.state.currency];
    },

    // Calculate the overround for a given market object
    // Param 'forExchange' is not used!
    getOverRound: function (marketObj, forExchange) {
        var forOverround = 0;
        var againstOverround = 0;
        for (selCount in marketObj.selections) {
            if (marketObj.selections[selCount].selectionStatusId == 2) {//Active

                if ((marketObj.selections[selCount].forExchangePrices[0] != null) && (forOverround != 9999))
                    forOverround += (1 / marketObj.selections[selCount].forExchangePrices[0].price);
                else { forOverround = 9999; }


                if ((marketObj.selections[selCount].againstExchangePrices[0] != null) && (againstOverround != 9999))
                    againstOverround += (1 / marketObj.selections[selCount].againstExchangePrices[0].price);
                else { againstOverround = 9999; }
                if ((againstOverround == 9999) && (forOverround == 9999))
                    break;
            }
        }

        forOverround = (forOverround == 9999) ? "" : this.formatDecimal(forOverround * 100, 2, '') + "%";
        againstOverround = (againstOverround == 9999) ? "" : this.formatDecimal(againstOverround * 100, 2, '') + "%";

        return { forOverround: forOverround, againstOverround: againstOverround };
    },
    getSubscribedOverround: function (marketObj, selectionIndex, oddsladder) {

        var forOverround = 0;
        var againstOverround = 0;
        var tempPrice = 0;
        for (selCount in marketObj.selections) {
            var thisSelection = marketObj.selections[selCount];
            var thisSubscribedSelection = selectionIndex[thisSelection.selectionId];
            if ((thisSubscribedSelection != null) && (thisSubscribedSelection.status == 2)) {//Active

                if (thisSubscribedSelection.backPrices
                    && (thisSubscribedSelection.backPrices[0] != null)
                    && (thisSubscribedSelection.backPrices[0].displayPrice != "")
                    && (forOverround != 9999)) {

                    var priceObj = oddsladder.getFromRepresentation(thisSubscribedSelection.backPrices[0].displayPrice);
                    if (priceObj == null) break;
                    tempPrice = priceObj.price;
                    forOverround += (1 / tempPrice);

                } else {
                    forOverround = 9999;
                }

                if (thisSubscribedSelection.layPrices
                    && (thisSubscribedSelection.layPrices[0] != null)
                    && (thisSubscribedSelection.layPrices[0].displayPrice != "")
                    && (againstOverround != 9999)) {

                    var priceObj = oddsladder.getFromRepresentation(thisSubscribedSelection.layPrices[0].displayPrice);
                    if (priceObj == null) break;
                    tempPrice = priceObj.price;
                    againstOverround += (1 / tempPrice);

                } else {
                    againstOverround = 9999;
                }

                if ((againstOverround == 9999) && (forOverround == 9999))
                    break;
            }
        }

        forOverround = (forOverround == 9999) ? "" : this.formatDecimal(forOverround * 100, 2, '') + "%";
        againstOverround = (againstOverround == 9999) ? "" : this.formatDecimal(againstOverround * 100, 2, '') + "%";

        return { forOverround: forOverround, againstOverround: againstOverround };
    },

    getUIDate: function (dateObject) {
        var monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            newDate = new Date(dateObject),
            year = newDate.getFullYear(),
            month = newDate.getMonth(),
            day = newDate.getDate(),
            resultDate;
        if (day === 1 || day === 21 || day === 31) {
            day = day + 'st';
        } else if (day === 2 || day === 22) {
            day = day + 'nd';
        } else if (day === 3 || day === 23) {
            day = day + 'rd';
        } else {
            day = day + 'th';
        }
        resultDate = day + ' ' + monthArray[month] + ' ' + year;
        return resultDate;
    },
    jsDate: function (utc) {

        if (!(typeof utc == "string")) {
            return utc;
        }
        //"2012-04-04T14:17:57.396Z"(UTC)
        //or "2012-04-04T14:17:57.396"(without Z. assuming it as UTC)
        //or "2012-03-30T15:23:00.93+01:00" (Local with offset)
        var d, _hours = "00", _minutes = "00", _seconds = "00", _milliseconds = "00", _year, _month, _day, _zoneDiff = 0,
            _datepart, _timePart;

        //first check is it a localised date.2011-03-31T18:15:00
        _timePart = utc.split("T")[1];
        if (_timePart && !/(Z|\.|\+|\-)/i.test(_timePart)) {//"2013-07-16T14:00:00"
            _datepart = utc.split("T")[0];
            _year = _datepart.split("-")[0];
            _month = (_datepart.split("-")[1] * 1) - 1;
            _day = _datepart.split("-")[2];
            _timePart = utc.split("T")[1];
            if (_timePart) {
                _timePart = _timePart.split(":");
                if (_timePart.length) {
                    _hours = _timePart[0];
                    _minutes = _timePart[1];
                    _seconds = _timePart[2];
                    return new Date(_year, _month, _day, _hours, _minutes, _seconds);
                }
            }
        }

        d = new Date(utc);
        if (isNaN(d)) {
            _datepart = utc.split("T")[0];
            _year = _datepart.split("-")[0];
            _month = (_datepart.split("-")[1] * 1) - 1;
            _day = _datepart.split("-")[2];
            _timePart = utc.split("T")[1];

            if (_timePart) {//15:23:00.93+01:00 or 14:17:57.396Z or 14:17:57.396 (without Z. assuming it as UTC)
                if (_timePart.match(/[+-]/) === null) {//if timezone offset not present
                    if (_timePart.match(/[Z]/) === null) {
                        _timePart += "Z"; //work around if utc date without trailing 'Z'
                    }
                }
                //15:23:00.93+01:00 or 14:17:57.396Z
                _timePart = _timePart.split(":");
                _hours = _timePart[0];
                _minutes = _timePart[1];
                if (_timePart[2]) {//00.93+01:00 or 57.396Z
                    _seconds = _timePart[2].substr(0, 2);
                    _temp = _timePart[2];
                    if (_timePart[3]) {
                        _temp += ":" + _timePart[3];
                    } //00.93+01:00 or 57.396Z
                    _seconds = _temp.substr(0, 2);
                    _timePart = _temp.split(".");
                    _milliseconds = _timePart[1] ? _timePart[1] : "00";
                    _timePart = _timePart[1] ? _timePart[1] : _timePart[0];
                }
                if (_timePart.match(/[+-]/) !== null) {//if timezone offset present.//93+01:00
                    var _months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                        _days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                    if (_timePart.match(/[+]/) !== null) { //+
                        _milliseconds = _milliseconds.substr(0, _timePart.lastIndexOf("+"));
                        _zoneDiff = _timePart.substring(_timePart.indexOf("+"));
                    } else { //-
                        _milliseconds = _timePart.substr(0, _timePart.lastIndexOf("-"));
                        _zoneDiff = _timePart.substring(_timePart.indexOf("-"));
                    }
                    _zoneDiff = _zoneDiff.split(":").join("");
                    d = new Date(_year, _month, _day);
                    d = new Date(_days[d.getDay()] + " " + _months[d.getMonth()] + " " + d.getDate() + " " + d.getFullYear() + " " + _hours + ":" + _minutes + ":" + _seconds + " UTC" + _zoneDiff);
                    d.setMilliseconds(_milliseconds);
                    return d;
                }
                //396Z
                _milliseconds = _timePart.substr(0, _timePart.lastIndexOf("Z"));
                _zoneDiff = new Date(_year, _month, _day).getTimezoneOffset();
            }
            d = new Date(_year, _month, _day, _hours, _minutes, _seconds, _milliseconds);
            if (_zoneDiff) {//reduce offset if UTC time as input(Z) to make it local.
                d = new Date(d.getTime() - (_zoneDiff * 60000));
            }
        }
        return d;
    },

    setCookie: function (c_name, value, expiredays, sameSite) {

        var exdate = new Date();
        var domain = this.getTopDomain();

        if (domain.indexOf('.') > -1) domain = ";domain=." + domain; else domain = ""; //to support non localhost

        exdate.setTime(exdate.getTime() + (60000 * 60 * 24 * expiredays));

        var expiry = ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());

        var sameSiteFlag = "";
        if (sameSite !== undefined) {
            sameSiteFlag = "SameSite=" + sameSite + ";";
        }

        try {
            document.cookie = c_name + "=" + escape(value) + expiry + domain + ';secure;path=/;' + sameSiteFlag;
        } catch (ex) {
            console.warn("Error setting cookie: " + c_name + "=" + escape(value) + expiry + domain + ';secure;path=/;' + sameSiteFlag);
            console.warn(ex);
        }

        if (sameSite === "None"
            && com.globalbettingexchange.base.getCookie(c_name) !== value) {

            console.warn("Cookie " + c_name + " was not created (with SameSite=None), this can happen in some legacy browsers, trying again without SameSite=None");
            // Setting cookie with "SameSite=None" can fail in some legacy browsers.
            // So if cookie is not set, then try again without "SameSite=None".

            try {
                document.cookie = c_name + "=" + escape(value) + expiry + domain + ';secure;path=/;';
            } catch (ex) {
                console.warn("Error setting cookie: " + c_name + "=" + escape(value) + expiry + domain + ';secure;path=/;');
                console.warn(ex);
            }

            if (com.globalbettingexchange.base.getCookie(c_name) !== value) {
                console.warn("Cookie " + c_name + " was not created (without SameSite=None)");
            }
        }
    },
    getCookie: function (c_name) {
        if (document.cookie.length > 0) {
            c_start = document.cookie.indexOf(c_name + "=");
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                c_end = document.cookie.indexOf(";", c_start);
                if (c_end == -1) c_end = document.cookie.length;
                return unescape(document.cookie.substring(c_start, c_end));
            }
        }
        return "";
    },
    deleteCookie: function (c_name) {
        var exdate = new Date();
        var domain = this.getTopDomain();

        if (domain.indexOf('.') > -1) domain = ";domain=." + domain; else domain = ""; //to support non localhost

        exdate.setDate(exdate.getDate() - 1);

        try {
            document.cookie = c_name + "=" + ";expires=" + exdate.toGMTString() + domain + ';secure;path=/;';
        } catch (ex) {
            console.warn("Error deleting cookie: " + c_name);
            console.warn(ex);
        }

        if (com.globalbettingexchange.base.getCookie(c_name) !== "") {

            console.warn("Cookie was not deleted. Trying again with \"SameSite=None\"");

            try {
                document.cookie = c_name + "=" + ";expires=" + exdate.toGMTString() + domain + ';secure;path=/;SameSite=None';
            } catch (ex) {
                console.warn("Error deleting cookie: " + c_name + " (with SameSite=None)");
                console.warn(ex);
            }

            if (com.globalbettingexchange.base.getCookie(c_name) !== "") {
                console.warn("Cookie was not deleted (with \"SameSite=None\")");
            }
        }

    },

    // Date object has it's own getFullYear() method, which seems to be what we use everywhere
    // I don't think this function is ever called from any component, but difficult to be 100% sure
    getFullYear: function (d) //returns the correct year for any year after 1000
    {
        console.log("gbe.base.js: getFullYear() function is deprecated and will be deleted."
            + "Use getFullYear() method on Date object instead");

        var y = d.getYear();
        if (y < 1000) y += 1900;
        return y;
    },

    // Returns last element from string delimited with '~' character
    getEventName: function (fullName) {
        return fullName.substring(fullName.lastIndexOf('~') + 1);
    },

    // Follows event tree towards root, via getParent() for each event,
    // until it reaches the top-level event (i.e. the one under the root)
    getTopLevelEvent: function (ev) {

        var parent = ev.getParent();

        if (parent == null)
            return ev;
        else
            return this.getTopLevelEvent(parent);

    },


    // If 'ev' is a descendent event of any of the events in 'ar',
    // then this function returns the event that it is a descendent of.
    // As it traverses the tree towards the root, it will return the
    // FIRST ancestor event of 'ev' that it encounters that is in 'ar'.
    // The order of the events in 'ar' is not important.
    // If 'ev' is NOT a descendent event of the any of the events in 'ar', then boolean false is returned.
    // 'ar' is an associative array (i.e. an object) indexed by eventClassifierId
    isDescendantOf: function (ev, ar) {

        if (ar == null) return false;

        if (ar[ev.eventClassifierId] != null) return ar[ev.eventClassifierId];

        var parent = ev.getParent();
        if (parent == null) {
            if (ar[1] != null)
                return ar[1];
            else
                return false;
        } else
            return this.isDescendantOf(parent, ar);
    },

    // Returns the whole setting object as opposed to boolean
    isDescendantOfObject: function (ev, ar) {

        if (ar == null) return null;

        if (ar[ev.eventClassifierId] != null) return ar[ev.eventClassifierId];

        var parent = ev.getParent();
        if (parent == null) {
            if (ar[1] != null)
                return ar[1];
            else
                return null;
        } else
            return this.isDescendantOfObject(parent, ar);
    },

    // Returns true if 'ancestor' is an ancestor event of event 'node'
    hasAncestor: function (node, ancestor) {

        var parent;

        if (node == null || ancestor == null) {
            return false;
        }
        if (node.eventClassifierId == ancestor.eventClassifierId) {
            return true;
        }
        else {
            if ((parent = node.getParent()) == null) {
                return false;
            } else {
                return this.hasAncestor(parent, ancestor);
            }
        }
    },

    // Gets the number of levels deep of event root is 0, top level is 1
    getEventLevel: function (ev) {
        var parent = ev.getParent();
        if (parent == null)
            return 1;
        else
            return this.getEventLevel(parent) + 1;

    },

    // Returns an array of ids from array of objects
    toPropArray: function (ar, prop) {
        var newAr = [];
        for (var i = 0; i < ar.length; i++) {
            newAr[i] = ar[i][prop];
        }

        return newAr;
    },

    toArrayFromIndex: function (ar) {
        var newAr = [];
        for (i in ar) {
            newAr.push(i);
        }

        return newAr;
    },

    /**
    * Capitalise only the first letter of each word
    * @param {string} str - string to capitalize
    * @return {string} – string that has been capitilized
    */
    toTitleCase: function (str) {
        "use strict";
        if (str !== undefined && str !== null) {
            return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
        } else {
            return "";
        }

    },

    getRefreshRate: function (markets, forLoggedInUser, rates) {

        if (markets.length == 0) {
            return 120000;
        }

        var market, i, startTime, forInRunningMarketOnly, currentTime, diffMinutes, rateObject;

        for (i = 0; i < markets.length; i = i + 1) {
            if (markets[i].startTime != null) {
                market = markets[i];
                break;
            }
        }

        if (market == null) {
            return 120000;
        }

        startTime = this.jsDate(market.startTime);
        forInRunningMarketOnly = market.isCurrentlyInRunning;

        currentTime = new Date();
        rate = 100000;
        diffMinutes = (startTime.getTime() - currentTime.getTime()) / 1000; //result in minutes

        rateObject = {
            forLoggedInUser: false,
            from: 86400,
            to: 0,
            forInRunningMarketOnly: false,
            rate: 3600
        };

        for (refreshI in rates.RefreshRates) {
            rateObject = rates.RefreshRates[refreshI];

            if ((rateObject.forLoggedInUser == forLoggedInUser) && (rateObject.forInRunningMarketOnly == forInRunningMarketOnly)) {
                if ((rateObject.from <= diffMinutes || rateObject.from === 0) && ((diffMinutes < rateObject.to) || rateObject.to === 0)) {
                    break;
                }
            }
        }

        if (rates.RefreshRateLimits.enabled) {
            var numMarketsInView = markets.length;
            var selectionsLimit = {};
            var marketsLimit = {};
            var numSelectionsInView = 0;

            for (rateI in rates.RefreshRateLimits.RefreshRates) {
                if ((rates.RefreshRateLimits.RefreshRates[rateI].numberOfMarkets > 0) && (rates.RefreshRateLimits.RefreshRates[rateI].enabled)) {
                    marketsLimit = rates.RefreshRateLimits.RefreshRates[rateI];
                    if ((numMarketsInView >= marketsLimit.numberOfMarkets) && (marketsLimit.rate > rateObject.rate))
                        return marketsLimit.rate * 1000;
                }

                if ((rates.RefreshRateLimits.RefreshRates[rateI].numberOfSelections > 0) && (rates.RefreshRateLimits.RefreshRates[rateI].enabled)) {
                    selectionsLimit = rates.RefreshRateLimits.RefreshRates[rateI];
                    for (marketI in markets) {
                        numSelectionsInView += markets[marketI].selections.length;
                    }
                    if ((numSelectionsInView >= selectionsLimit.numberOfSelections) && (selectionsLimit.rate > rateObject.rate))
                        return selectionsLimit.rate * 1000;
                }
            }

        }

        return rateObject.rate * 1000;
    },

    // Returns URL-encoded version of the specified string
    urlencode: function (str) {

        // Bug: for characters '*' and '@', only the first instance is replaced
        // Bug: for space characters, the first is replaced by "+", the rest by "%20"

        str = escape(str);
        str = str.replace(/\+/g, "%2B");
        str = str.replace('%20', '+');
        str = str.replace('*', '%2A');
        str = str.replace(/\'/g, '%27');
        str = str.replace('@', '%40');
        return str;
    },

    marketTypeName: function (id) {
        var returnVal = 'Unknown';
        switch (id) {
            case 1: returnVal = 'Win'; break;
            case 2: returnVal = 'Place'; break;
            case 3: returnVal = 'Match Odds'; break;
            case 4: returnVal = 'OverUnder'; break;
            case 10: returnVal = 'AsianHandicap'; break;
            case 11: returnVal = 'TwoBall'; break;
            case 12: returnVal = 'Three Ball'; break;
            case 13: returnVal = ''; break;
            case 14: returnVal = 'Match'; break;
            case 15: returnVal = 'Set'; break;
            case 16: returnVal = 'Moneyline'; break;
            case 17: returnVal = 'Total'; break;
            case 18: returnVal = 'Handicap'; break;
            case 19: returnVal = 'EachWay NonHandicap'; break;
            case 20: returnVal = 'EachWay Handicap'; break;
            case 21: returnVal = 'EachWay Tournament'; break;
            case 22: returnVal = 'Running Ball'; break;
            case 23: returnVal = 'Match Betting'; break;
            case 24: returnVal = 'Match Betting Incl Draw'; break;
            case 25: returnVal = 'CorrectScore'; break;
            case 26: returnVal = 'HalfTime FullTime'; break;
            case 27: returnVal = 'Total Goals'; break;
            case 28: returnVal = 'Goals Scored'; break;
            case 29: returnVal = 'Corners'; break;
            case 30: returnVal = 'OddsOrEvens'; break;
            case 31: returnVal = 'HalfTime Result'; break;
            case 32: returnVal = 'HalfTime Score'; break;
            case 33: returnVal = 'Match Odds ExtraTime'; break;
            case 34: returnVal = 'Correct Score ExtraTime'; break;
            case 35: returnVal = 'Over Under Extra Time'; break;
            case 36: returnVal = 'To Qualify'; break;
            case 37: returnVal = 'Draw NoBet'; break;
            case 39: returnVal = 'Halftime AsianHcp'; break;
            case 40: returnVal = 'Halftime OverUnder'; break;
            case 41: returnVal = 'Next Goal'; break;
            case 42: returnVal = 'First Goalscorer'; break;
            case 43: returnVal = 'Last Goalscorer'; break;
            case 44: returnVal = 'Player To Score'; break;
            case 45: returnVal = 'FirstHalf Handicap'; break;
            case 46: returnVal = 'FirstHalf Total'; break;
            case 47: returnVal = 'Set Betting'; break;
            case 48: returnVal = 'Group Betting'; break;
            case 49: returnVal = 'Matchplay Single'; break;
            case 50: returnVal = 'Matchplay Fourball'; break;
            case 51: returnVal = 'Matchplay Foursome'; break;
            case 52: returnVal = 'Tied Match'; break;
            case 53: returnVal = 'Top Batsman'; break;
            case 54: returnVal = 'Innings Runs'; break;
            case 55: returnVal = 'Total Tries'; break;
            case 56: returnVal = 'Total Points'; break;
            case 57: returnVal = 'Frame Betting'; break;
            case 58: returnVal = 'To Score First'; break;
            case 59: returnVal = 'To Score Last'; break;
            case 60: returnVal = 'First Scoring Play'; break;
            case 61: returnVal = 'Last Scoring Play'; break;
            case 62: returnVal = 'Highest Scoring Qtr'; break;
            case 63: returnVal = 'RunLine'; break;
            case 64: returnVal = 'Round Betting'; break;
            default: returnVal = 'type ' + id; break;
        }
        return returnVal;

    },

    calcPnLs: function (markets, orders) {
        if (orders == null)
            orders = [];
        var marketTotals = []; //Array to hold total PL for each market
        var selectionTotals = []; //Array to hold total PL for each selection
        var marketTotals1 = []; //Indexed Array to hold total PL for each market
        var selectionTotals1 = []; //Indexed Array to hold total PL for each selection
        var _markets = {};
        for (var m = 0; m < markets.length; m++) {
            _markets[markets[m].marketId] = markets[m];
        }

        for (var i = 0; i < orders.length; i++) {
            var o = orders[i];
            if (marketTotals1[o.marketId()] == null) {
                marketTotals1[o.marketId()] = {};
                marketTotals1[o.marketId()].allSelectionsLosePnL = 0;
            }

            if (selectionTotals1[o.selectionId()] == null) {
                selectionTotals1[o.selectionId()] = {};
                selectionTotals1[o.selectionId()].selectionPnL = 0;
                selectionTotals1[o.selectionId()].selectionPnL1 = 0;
                selectionTotals1[o.selectionId()].selectionPnL2 = 0;
                selectionTotals1[o.selectionId()].selectionPnL3 = 0;
            }

            var m = _markets[o.marketId()];
            var polMultiple = (o.polarityId == 1) ? 1 : -1;

            if (![19, 20, 21].includes(m.marketTypeId)) {//not eachway

                marketTotals1[o.marketId()].allSelectionsLosePnL -= polMultiple * (o.matchedStake);
                selectionTotals1[o.selectionId()].selectionPnL += polMultiple * (o.averageMatchedPrice * o.matchedStake);
                selectionTotals1[o.selectionId()].selectionPnL1 += polMultiple * ((o.averageMatchedPrice - 1) * o.matchedStake);
                selectionTotals1[o.selectionId()].selectionPnL2 -= polMultiple * o.matchedStake;
            }
            else {
                var p = o.placePayout();

                selectionTotals1[o.selectionId()].selectionPnL1 += polMultiple * o.averageMatchedPrice * (o.matchedStake / 2);
                selectionTotals1[o.selectionId()].selectionPnL2 -= polMultiple * (o.averageMatchedPrice * -1) * (o.matchedStake / 2) - (o.matchedStake / 2);
                selectionTotals1[o.selectionId()].selectionPnL3 -= polMultiple * o.matchedStake;
            }
        }

        for (var marketCount in _markets) {
            m = _markets[marketCount];
            if (m.numberOfWinningSelections == 1) {
                // Market has only one winner

                // For each selection in the market, calculate P&L
                for (var selection in m.selections) {
                    var s = m.selections[selection];

                    var marketPnL = (marketTotals1[m.marketId] == null) ? 0 : marketTotals1[m.marketId].allSelectionsLosePnL;
                    var selectionPnL = (selectionTotals1[s.selectionId] == null) ? 0 : selectionTotals1[s.selectionId].selectionPnL;

                    selectionTotals[s.selectionId] = {};
                    selectionTotals[s.selectionId].PnL1 = marketPnL + selectionPnL;
                    selectionTotals[s.selectionId].PnL2 = -999999;   // special value meaning there is no P&L figure
                    selectionTotals[s.selectionId].PnL3 = -999999;   // special value meaning there is no P&L figure
                }
            }
            else {

                if (![19, 20, 21].includes(m.marketTypeId)) {
                    // number of winners not equal to 1, therefore show 2 P&L figures

                    // For each selection in the market, calculate P&L
                    for (selectionCount in m.selections) {
                        var s = m.selections[selectionCount];

                        var selectionPnL1 = (selectionTotals1[s.selectionId] == null) ? 0 : selectionTotals1[s.selectionId].selectionPnL1;
                        var selectionPnL2 = (selectionTotals1[s.selectionId] == null) ? 0 : selectionTotals1[s.selectionId].selectionPnL2;

                        selectionTotals[s.selectionId] = {};
                        selectionTotals[s.selectionId].PnL1 = selectionPnL1;
                        selectionTotals[s.selectionId].PnL2 = selectionPnL2;
                        selectionTotals[s.selectionId].PnL3 = -999999;  // special value meaning there is no P&L figure
                    }
                } else {//eachway
                    for (selectionCount in m.selections) {
                        var s = m.selections[selectionCount];

                        var selectionPnL1 = (selectionTotals1[s.selectionId] == null) ? 0 : selectionTotals1[s.selectionId].selectionPnL1;
                        var selectionPnL2 = (selectionTotals1[s.selectionId] == null) ? 0 : selectionTotals1[s.selectionId].selectionPnL2;
                        var selectionPnL3 = (selectionTotals1[s.selectionId] == null) ? 0 : selectionTotals1[s.selectionId].selectionPnL2;

                        selectionTotals[s.selectionId] = {};
                        selectionTotals[s.selectionId].PnL1 = selectionPnL1;
                        selectionTotals[s.selectionId].PnL2 = selectionPnL1;
                        selectionTotals[s.selectionId].PnL3 = selectionPnL2;
                    }

                }
            }
        }
        return selectionTotals;
    },
    calcPushPnLs: function (markets, orders) {
        if (orders == null)
            orders = [];
        var marketTotals = {}; //Array to hold total PL for each market
        var selectionTotals = {}; //Array to hold total PL for each selection
        var marketTotals1 = {}; //Indexed Array to hold total PL for each market
        var selectionTotals1 = {}; //Indexed Array to hold total PL for each selection

        for (var i = 0; i < orders.length; i++) {
            var o = orders[i];
            if (marketTotals1[o.marketId()] == null) {
                marketTotals1[o.marketId()] = {};
                marketTotals1[o.marketId()].allSelectionsLosePnL = 0;
            }

            if (selectionTotals1[o.selectionId()] == null) {
                selectionTotals1[o.selectionId()] = {};
                selectionTotals1[o.selectionId()].selectionPnL = 0;
                selectionTotals1[o.selectionId()].selectionPnL1 = 0;
                selectionTotals1[o.selectionId()].selectionPnL2 = 0;
            }

            if (orders[i].polarity == 1) {
                marketTotals1[o.marketId()].allSelectionsLosePnL -= o.matchedStake;
                selectionTotals1[o.selectionId()].selectionPnL += (o.averageMatchedPrice) * o.matchedStake;
                selectionTotals1[o.selectionId()].selectionPnL1 += (o.averageMatchedPrice - 1) * o.matchedStake;
                selectionTotals1[o.selectionId()].selectionPnL2 -= o.matchedStake;
            } else {
                marketTotals1[o.marketId()].allSelectionsLosePnL += o.matchedStake;
                selectionTotals1[o.selectionId()].selectionPnL -= (o.averageMatchedPrice) * o.matchedStake;
                selectionTotals1[o.selectionId()].selectionPnL1 -= (o.averageMatchedPrice - 1) * o.matchedStake;
                selectionTotals1[o.selectionId()].selectionPnL2 += o.matchedStake;
            }
        }

        for (var marketCount in markets) {
            m = markets[marketCount];
            if (m.numberOfWinningSelections == 1) {
                // Market has only one winner

                // For each selection in the market, calculate P&L
                for (var selection in m.selections) {
                    var s = m.selections[selection];

                    var marketPnL = (marketTotals1[m.marketId] == null) ? 0 : marketTotals1[m.marketId].allSelectionsLosePnL;
                    var selectionPnL = (selectionTotals1[s.selectionId] == null) ? 0 : selectionTotals1[s.selectionId].selectionPnL;

                    selectionTotals[s.selectionId] = {};
                    selectionTotals[s.selectionId].PnL1 = marketPnL + selectionPnL;
                    selectionTotals[s.selectionId].PnL2 = -999999;   // special value meaning there is no P&L figure
                    selectionTotals[s.selectionId].PnL3 = -999999;   // special value meaning there is no P&L figure
                }
            }
            else {
                // number of winners not equal to 1, therefore show 2 P&L figures

                // For each selection in the market, calculate P&L
                for (selectionCount in m.selections) {
                    var s = m.selections[selectionCount];

                    var marketPnL = (marketTotals1[m.marketId] == null) ? 0 : marketTotals1[m.marketId].allSelectionsLosePnL;
                    var selectionPnL1 = (selectionTotals1[s.selectionId] == null) ? 0 : selectionTotals1[s.selectionId].selectionPnL1;
                    var selectionPnL2 = (selectionTotals1[s.selectionId] == null) ? 0 : selectionTotals1[s.selectionId].selectionPnL2;

                    selectionTotals[s.selectionId] = {};
                    selectionTotals[s.selectionId].PnL1 = selectionPnL1;
                    selectionTotals[s.selectionId].PnL2 = selectionPnL2;
                    selectionTotals[s.selectionId].PnL3 = -999999;  // special value meaning there is no P&L figure
                }
            }
        }
        return selectionTotals;
    },
    getTopDomain: function () {

        var domain = document.domain;
        var domainParts = domain.split('.');
        var topDomain = '';
        i = i;
        var partCount = 0;
        for (var i = domainParts.length - 1; i >= 0; i--) {
            partCount++;
            topDomain = domainParts[i] + '.' + topDomain;
            if ((partCount > 1) && (domainParts[i] !== "co")) break;
        }

        return topDomain.substring(0, topDomain.length - 1);
    },

    // Returns object containing text and CSS class to indicate the status of an order
    orderStatusName: function (order) {

        var statusClass = '', statusText = '';

        if (order.requestedStake == order.matchedStake) {

            statusClass = 'gep-icon-matched';
            statusText = gep._settings.resources.OrderStatus.Matched;

        } else if ((order.matchedStake == 0) && (order.orderStatusId == 3)) {

            statusClass = 'gep-icon-unmatched';
            statusText = gep._settings.resources.OrderStatus.Cancelled;

        } else if ((order.matchedStake > 0) && (order.orderStatusId == 3)) {

            statusClass = 'gep-icon-matched';
            statusText = gep._settings.resources.OrderStatus.Matched;

        } else if (order.matchedStake == 0) {

            statusClass = 'gep-icon-unmatched';
            statusText = gep._settings.resources.OrderStatus.Unmatched;

        } else {

            statusClass = 'gep-icon-partmatched';
            statusText = gep._settings.resources.OrderStatus.PartMatched;
        }

        return { statusClass: statusClass, statusText: statusText };

    },

    BrowserDetect: {
        init: function () {
            this.browser = this.searchString(this.dataBrowser) || "unknown";
            this.version = this.searchVersion(navigator.userAgent)
                || this.searchVersion(navigator.appVersion)
                || "unknown";
            this.OS = this.searchString(this.dataOS) || "unknown";
            this.msie = (this.browser == "Explorer");
        },

        searchString: function (data) {
            for (var i = 0; i < data.length; i++) {
                var dataString = data[i].string;
                var dataProp = data[i].prop;
                this.versionSearchString = data[i].versionSearch || data[i].identity;
                if (dataString) {
                    if (dataString.indexOf(data[i].subString) != -1)
                        return data[i].identity;
                }
                else if (dataProp)
                    return data[i].identity;
            }
        },
        searchVersion: function (dataString) {
            var index = dataString.indexOf(this.versionSearchString);
            if (index == -1) return;

            if ((dataString.indexOf("Windows NT 6.1;") > -1) || (dataString.indexOf("Windows NT 6.2;") > -1)) {
                return 10;
            }
            if ((dataString.indexOf("Windows NT 6.3;") > -1) || (dataString.indexOf("Windows NT 6.4;") > -1)) {
                return 11;
            }
            return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
        },
        dataBrowser: [
            {
                string: navigator.userAgent,
                subString: "Chrome",
                identity: "Chrome"
            },
            {
                string: navigator.userAgent,
                subString: "OmniWeb",
                versionSearch: "OmniWeb/",
                identity: "OmniWeb"
            },
            {
                string: navigator.vendor,
                subString: "Apple",
                identity: "Safari",
                versionSearch: "Version"
            },
            {
                prop: window.opera,
                identity: "Opera",
                versionSearch: "Version"
            },
            {
                string: navigator.vendor,
                subString: "iCab",
                identity: "iCab"
            },
            {
                string: navigator.vendor,
                subString: "KDE",
                identity: "Konqueror"
            },
            {
                string: navigator.userAgent,
                subString: "Firefox",
                identity: "Firefox"
            },
            {
                string: navigator.vendor,
                subString: "Camino",
                identity: "Camino"
            },
            {		// for newer Netscapes (6+)
                string: navigator.userAgent,
                subString: "Netscape",
                identity: "Netscape"
            },
            {
                string: navigator.userAgent,
                subString: "MSIE",
                identity: "Explorer",
                versionSearch: "MSIE"
            },
            {
                string: navigator.userAgent,
                subString: "Gecko",
                identity: "Mozilla",
                versionSearch: "rv"
            },
            { 		// for older Netscapes (4-)
                string: navigator.userAgent,
                subString: "Mozilla",
                identity: "Netscape",
                versionSearch: "Mozilla"
            }
        ],
        dataOS: [
            { string: navigator.platform, subString: "Win", identity: "Windows" },
            { string: navigator.platform, subString: "Mac", identity: "Mac" },
            { string: navigator.userAgent, subString: "iPad", identity: "iPad" },
            { string: navigator.userAgent, subString: "iPhone", identity: "iPhone" },
            { string: navigator.userAgent, subString: "iPod", identity: "iPod" },
            { string: navigator.platform, subString: "Linux", identity: "Linux" },
            { string: navigator.userAgent, subString: "Android", identity: "Android" },
            { string: navigator.userAgent, subString: "Apple-iPhone", identity: "Apple-iPhone" }, //	 //iPhone, 3G or 3GS with iOS 3.x
            { string: navigator.userAgent, subString: "Apple-iPhone1C2", identity: "Apple-iPhone1C2" }, //	 //iPhone 3G with iOS 4.x
            { string: navigator.userAgent, subString: "Apple-iPhone2C1", identity: "Apple-iPhone2C1" }, //	 //iPhone 3GS with iOS 4.x
            { string: navigator.userAgent, subString: "Apple-iPhone3C1", identity: "Apple-iPhone3C1" }, //	 //iPhone 4
            { string: navigator.userAgent, subString: "Apple-iPhone3C3", identity: "Apple-iPhone3C3" }, //	 //iPhone 4 CDMA
            { string: navigator.userAgent, subString: "Apple-iPhone4C1", identity: "Apple-iPhone4C1" }, //	 //iPhone 4S
            { string: navigator.userAgent, subString: "Apple-iPhone5C1", identity: "Apple-iPhone5C1" }, //	 //iPhone 5 GSM
            { string: navigator.userAgent, subString: "Apple-iPhone5C2", identity: "Apple-iPhone5C2" }, //	 //iPhone 5 CDMA
            { string: navigator.userAgent, subString: "OS 6_0", identity: "OS 6_0" }, //	 //iPhone 5S CDMA
            { string: navigator.userAgent, subString: "Apple-iPod", identity: "Apple-iPod" }, //	 //iPod touch 1st, 2nd or 3rd generation with iOS 3.x
            { string: navigator.userAgent, subString: "Apple-iPod2C1", identity: "Apple-iPod2C1" }, //	 //iPod touch 2nd generation with iOS 4.x
            { string: navigator.userAgent, subString: "Apple-iPod3C1", identity: "Apple-iPod3C1" }, //	// iPod touch 3rd generation with iOS 4.x
            { string: navigator.userAgent, subString: "Apple-iPod4C1", identity: "Apple-iPod4C1" }, //	 //iPod touch 4th generation
            { string: navigator.userAgent, subString: "Apple-iPod5C1", identity: "Apple-iPod5C1" }, //	// iPod touch 5th generation
            { string: navigator.userAgent, subString: "Apple-iPad", identity: "Apple-iPad" }, //	// iPad with iOS 3.2.x
            { string: navigator.userAgent, subString: "Apple-iPad1C1", identity: "Apple-iPad1C1" }, //	 //iPad with iOS 4.2.x
            { string: navigator.userAgent, subString: "Apple-iPad2C1", identity: "Apple-iPad2C1" }, //	 //iPad 2 WiFi
            { string: navigator.userAgent, subString: "Apple-iPad2C2", identity: "Apple-iPad2C2" }, //	 //iPad 2 WiFi + 3G GSM
            { string: navigator.userAgent, subString: "Apple-iPad2C3", identity: "Apple-iPad2C3" }, //	 //iPad 2 WiFi + 3G CDMA
            { string: navigator.userAgent, subString: "Apple-iPad3C1", identity: "Apple-iPad3C1" }, //	 //iPad (3rd generation) WiFi
            { string: navigator.userAgent, subString: "Apple-iPad3C2", identity: "Apple-iPad3C2" }, //	// iPad (3rd generation) WiFi + 4G Verizon / International
            { string: navigator.userAgent, subString: "Apple-iPad3C3", identity: "Apple-iPad3C3" }//	// iPad (3rd generation) WiFi + 4G AT&T / International


        ]

    },

    // Move functions such as this to exchange-specific base.js?
    convertToOrder: function (bet) {
        bet.marketId = bet.marketId();
        bet.marketName = bet.marketName();
        bet.eventClassifierFullName = bet.eventClassifierFullName();
        bet.eventClassifierId = bet.eventClassifierId();
        bet.selectionName = bet.selectionName();
        bet.selectionId = bet.selectionId();
        var order = new gec.Order(bet);
        order.matchingTimestamp = bet.placedAt;
        order.issuedAt = bet.placedAt;
        order.isFreeBet = bet.isFreeBet;
        order.expiresAt = "7000-12-31T00:00:00+00:00";
        order.isSportsbook = true;
        order.orderId = bet.localBetId;
        order.averageMatchedPrice = bet.punterPrice;
        order.requestedPrice = bet.punterPrice;
        order.orderStatusId = bet.betStatusId;
        order.requestedStake = bet.punterGrossAmountRequested || 0;
        order.matchedStake = bet.punterGrossAmountPlaced || 0;
        order.polarityId = bet.polarityId;
        order.placePayout = function () { return 0; }
        return order;
    },

    // Converts the properties of an object into an array (in order of the properties)
    convertToArray: function (input) {
        var output = [];
        for (i in input) {
            var item = input[i];
            item.name = i;
            output.push(item);
        }
        return output;
    },


    //get querystring parameter
    qs: function (key) {
        key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
        var match = location.search.match(new RegExp("[?&]" + key + "=([^&]+)(&|$)"));
        return match && decodeURIComponent(match[1].replace(/\+/g, " "));
    },

    formatXSP: function (sp) {
        /*
        If odds less than 10 – format will be X.XX - truncate at the third decimal place.
        If odds between 10 & 99 – format will be XX.X - truncate at the second decimal place.
        If odds greater than 99 – format will be up to XXXX -- truncate decimal places.
        */
        var nmbr = "", decml = "00", arr;
        if (!sp) {
            return "&nbsp;";
        }
        sp = sp + "";
        arr = sp.split('.');
        nmbr = arr[0];
        if (arr[1]) {
            decml = arr[1].substr(0, 2);
            if (decml.length == 1) {
                decml += "0";
            }
        }
        sp = sp * 1;
        if (sp < 10) {
            return nmbr + "." + decml;
        } else if (sp < 100) {
            return nmbr + "." + decml.substr(0, 1);
        } else if (sp > 100) {
            return nmbr;
        }
    },

    calculatePtnlReturns: function (selectedOdds, decimalOdds, stake, isEW) {
        var ptnlReturns = 0;
        if (selectedOdds === "SP") {
            ptnlReturns = "N/A";
        } else if (decimalOdds > 0) {
            if (isEW) {
                stake = stake / 2;
            }
            ptnlReturns = (stake * (decimalOdds - 1) * 1) + +(stake);
        }
        return ptnlReturns;
    },

    calculatePtnlProfit: function (selectedOdds, decimalOdds, stake, isEW) {
        var ptnlProfit = 0;
        if (selectedOdds === "SP") {
            ptnlProfit = "N/A";
        } else if (decimalOdds > 0) {
            if (isEW) {
                stake = stake / 2;
            }
            ptnlProfit = (stake * (decimalOdds - 1) * 1);
        }
        return ptnlProfit;
    },

    calcEachwayWinPrize: function (stake, fraction, decimalOdds, pol) {
        const sign = (pol === 1) ? 1 : -1;
        if (decimalOdds > 0) {
            return (stake * (decimalOdds - 1) + (stake * (decimalOdds - 1) * fraction)) * sign;
        }
        return 0;
    },

    calcEachwayPlacedPrize: function (stake, fraction, decimalOdds, pol) {
        const sign = (pol === 1) ? 1 : -1;
        if (decimalOdds > 0) {
            return ((stake * (decimalOdds - 1) * fraction) - stake) * sign;
        }

        return base.formatDecimal(0, 2, "", false);
    },

    calcEachwayUnPlacedPrize: function (stake, fraction, decimalOdds, pol) {
        const sign = (pol === 1) ? 1 : -1;
        if (decimalOdds > 0) {
            return (-stake * 2) * sign;
        }
        return base.formatDecimal(0, 2, "", false);
    },

    truncatePrice: function (odds, polarity) {
        var nmbr = "", arr, dcml, zeroPos = -1;
        if (!odds) {
            return 0;
        }
        odds = odds + "";
        arr = odds.split('.');
        nmbr = arr[0];
        dcml = arr[1];
        if (dcml) {
            if (dcml.length > 2) {
                dcml = dcml.substr(0, 2);//bets truncated, applicable to BACK bets
                if (polarity == 2) { //if more than 3 decimal, LAY bets are rounded up
                    zeroPos = dcml.indexOf("0"); //is the first digit 0, then prepend it later
                    dcml = dcml * 1;
                    if (dcml > 0) {
                        dcml += 1;
                        if (dcml > 99) {
                            dcml = "0";
                            nmbr++;
                            zeroPos = -1;
                        }
                        if (dcml < 10 && zeroPos == 0) {
                            dcml = "0" + dcml;
                        }
                    }
                }
            }
            odds = nmbr + "." + dcml;
        }
        return odds;
    },

    // Return element from array with property with name propertyName matching propertyValue
    getElementMatchingPropertyFromArray: function (array, propertyName, propertyValue) {

        var i;

        for (i = 0; i < array.length; i = i + 1) {
            if (array[i][propertyName] === propertyValue) {
                return array[i];
            }
        }

        return undefined;
    },

    // Return last item in a string delimited by a specific character (e.g. for "1,4,6" return "6")
    getLastElementInSeparatedString: function (string, separatorChar) {

        "use strict";

        var elements = string.split(separatorChar);

        if (elements.length > 0) {
            return elements[elements.length - 1];
        }

        return "";
    },

    getArrayOfTaggedValueNames: function (taggedValues) {
        if (!taggedValues) {
            return [];
        }

        return taggedValues.map(function (taggedValue) {
            return taggedValue.name;
        });
    },

    // If "Z" or timezone indicator is not present in string, add "Z" to explicitly indicate UTC
    explictlyMarkDateStringAsUTC: function (dateString) {

        // Example dateStrings
        // "2018-01-31T23:00:00"
        // "2018-01-31T23:00:00Z"
        // "2018-01-31T23:00:00-05:00"

        var timePart = dateString.split("T")[1];

        // If time part does not end with "Z" indicating UTC,
        // or "+HH:MM" or "-HH:MM" indicating time zone,
        // then add "Z" to explicitly indicate UTC
        if (!/(Z|\+|\-)/i.test(timePart)) {
            return dateString + "Z";
        }

        return dateString;
    },

    // Find cards for contest that is currently active, if any.
    // If more than one contest currently active (which shouldn't happen),
    // just use the first one we find.
    getCardsForCurrentlyActiveContest: function (contestGTVs, now) {

        var contestCards = [];
        contestGTVs.every(function (contestGTV) {

            var contestDetails;

            try {
                contestDetails = JSON.parse(contestGTV.value);
            } catch (ex) {
                console.error("Error parsing JSON from GTV '" + contestGTV.name + "'");
                console.error(contestGTV.value);
                return;
            }

            var contestStartTimeInUTC = com.globalbettingexchange.base.jsDate(
                com.globalbettingexchange.base.explictlyMarkDateStringAsUTC(contestDetails.startTime)
            );

            var contestEndTimeInUTC = com.globalbettingexchange.base.jsDate(
                com.globalbettingexchange.base.explictlyMarkDateStringAsUTC(contestDetails.endTime)
            );

            if (now.getTime() >= contestStartTimeInUTC.getTime()
                && now.getTime() <= contestEndTimeInUTC.getTime()) {

                contestCards = contestDetails.cards;
                return false;   // exit loop
            }
            return true;
        });

        return contestCards;
    }
};

com.globalbettingexchange.base.processGTVs = function (gtvResponse, clientSettings, partner, profile, revivers) {
    'use strict';
    var partnerIdentifier = String.format("GEP.I{0}P{1}.{2}.", partner.integrationPartnerId, partner.pseudoIntegrationPartnerId, profile),
        whiteLabelIdentifier = String.format("GEP.I{0}P{1}.{2}.{3}.", partner.integrationPartnerId, partner.pseudoIntegrationPartnerId, profile, partner.whiteLabel || ''),
        whiteLabelIdentifierV2 = String.format("GEP.I{0}P{1}-{3}.{2}.", partner.integrationPartnerId, partner.pseudoIntegrationPartnerId, profile, partner.whiteLabel || ''),
        reviver, //use to store the current reviver function to call for a GTV
        whiteLabelSpecificTags = {}, // used to store list of GTVs specific to a white label, these overwrite other GTVs of same name
        whiteLabelSpecificTagsV2 = {},
        modeSpecificTags = {}, // used to store GTVs specific to exchange or sportsbook
        tagI,
        s,
        configName,
        configValue,
        mode;

    partner.GEPstate = partner.GEPstate || { mode: "exchange" };

    switch (partner.GEPstate.mode) {
        case "sportsbook": mode = "Sportsbook"; break;
        case "casino": mode = "Casino"; break;
        case "sportspools": mode = "Sportspools"; break;
        case "pages": mode = "Pages"; break;
        case "promotions": mode = "Promotions"; break;
        default: mode = "Exchange"; break;
    }
    var modeIdentifier = String.format("GEP.I{0}P{1}.{2}.{3}.", partner.integrationPartnerId, partner.pseudoIntegrationPartnerId, profile, mode),
        //modeIdentifierV2 = String.format("GEP.I{0}P{1}.{2}.{3}.", partner.integrationPartnerId, partner.pseudoIntegrationPartnerId, profile, mode),
        revivers = revivers || {};

    if (partner.gtvIndetifier !== undefined) {
        mode = partner.mode;
        partnerIdentifier = String.format("{0}.{1}.", partner.gtvIndetifier, profile);
        whiteLabelIdentifier = String.format("{0}.{1}.{2}.", partner.gtvIndetifier, profile, partner.whiteLabel || '');
        whiteLabelIdentifierV2 = String.format("{0}-{2}.{1}.", partner.gtvIndetifier, profile, partner.whiteLabel || '');

        modeIdentifier = String.format("{0}.{1}.{2}.", partner.gtvIndetifier, profile, mode);
    }

    function lowercaseFirstLetter(aString) {
        return aString.charAt(0).toLowerCase() + aString.slice(1);
    }
    function replaceWhitelabelDomain(aString) {
        return aString.replace(/\[whitelabeldomain\]/g, partner.whitelabelDomain).replace(/\[whitelabel\]/g, partner.whiteLabel.toLowerCase()).replace(/\[brokerid\]/g, partner.brokerId);
    }

    for (tagI in gtvResponse) {
        if (gtvResponse.hasOwnProperty(tagI)) {
            configName = lowercaseFirstLetter(gtvResponse[tagI].name.replace(partnerIdentifier, ""));

            try {
                if (gtvResponse[tagI].value !== "") {

                    var value = replaceWhitelabelDomain(gtvResponse[tagI].value);
                    if (value === "TRUE" || value === "FALSE") {
                        configValue = value;
                    } else {
                        configValue = JSON.parse(value);
                    }
                } else {
                    configValue = gtvResponse[tagI].value;
                }


            } catch (ex) {

                configValue = gtvResponse[tagI].value;
            }


            if (gtvResponse[tagI].name.indexOf(modeIdentifier) === 0) {
                configName = lowercaseFirstLetter(gtvResponse[tagI].name.replace(modeIdentifier, ""));
                modeSpecificTags[configName] = configValue;

                if (gtvResponse[tagI].name.indexOf(modeIdentifier + partner.whiteLabel) === 0) {
                    configName = lowercaseFirstLetter(gtvResponse[tagI].name.replace(modeIdentifier + partner.whiteLabel, ""));
                    whiteLabelSpecificTags[configName] = configValue;
                }


            } else if (gtvResponse[tagI].name.indexOf(whiteLabelIdentifier) === 0) {
                configName = lowercaseFirstLetter(gtvResponse[tagI].name.replace(whiteLabelIdentifier, ""));
                whiteLabelSpecificTags[configName] = configValue;

                if (gtvResponse[tagI].name.indexOf(whiteLabelIdentifier + mode) === 0) {
                    configName = lowercaseFirstLetter(gtvResponse[tagI].name.replace(whiteLabelIdentifier + mode, ""));
                    whiteLabelSpecificTags[configName] = configValue;

                }
            } else if (gtvResponse[tagI].name.indexOf(whiteLabelIdentifierV2) === 0) {
                configName = lowercaseFirstLetter(gtvResponse[tagI].name.replace(whiteLabelIdentifierV2, ""));

                var whitelabelModeKey = whiteLabelIdentifierV2 + mode + ".";
                if (gtvResponse[tagI].name.indexOf(whitelabelModeKey) === 0) {
                    configName = lowercaseFirstLetter(gtvResponse[tagI].name.replace(whitelabelModeKey, ""));
                    whiteLabelSpecificTagsV2[configName] = configValue;

                } else {
                    whiteLabelSpecificTagsV2[configName] = configValue;
                }
            } else {
                reviver = revivers[configName];
                reviver = revivers[configName.toLowerCase()] || reviver;//if lowercase reviver then use that

                if (reviver !== undefined) {
                    configValue = reviver(configValue);
                }

                clientSettings[configName] = configValue;
            }
        }

    }

    for (s in modeSpecificTags) {
        if (modeSpecificTags.hasOwnProperty(s)) {
            clientSettings[s] = modeSpecificTags[s];
        }
    }
    for (s in whiteLabelSpecificTags) {
        if (whiteLabelSpecificTags.hasOwnProperty(s)) {
            clientSettings[s] = whiteLabelSpecificTags[s];
        }
    }
    for (s in whiteLabelSpecificTagsV2) {
        if (whiteLabelSpecificTagsV2.hasOwnProperty(s)) {
            clientSettings[s] = whiteLabelSpecificTagsV2[s];
        }
    }

};


// Convert specified object property from a MoneyAmount {currency, amount} to MoneyValue (simple JS Number)
com.globalbettingexchange.base.convertMoneyAmountPropertyToMoneyValue = function (object, propertyName) {
    if (object[propertyName] !== undefined) {
        object[propertyName] = object[propertyName].amount;
    }
};


(function () {
    if (typeof (Storage) !== "undefined") {
        com.globalbettingexchange.base.supportLS = true;
    }
})();


// Replaces "{0}", "{1}", etc. in a string with supplied arguments
// Note: Only replaces maximum of two instances of a each placeholder ("{0}" is a placeholder)
String.format = function (frmt, args) {

    for (var x = 0; x < arguments.length; x++) {

        frmt = frmt.replace("{" + x + "}", arguments[x + 1]);
        frmt = frmt.replace("{" + x + "}", arguments[x + 1]);

    }

    return frmt;
}

// Returns a string containing a given string repeated N times
String.repeat = function (chr, count) {

    var str = "";

    for (var x = 0; x < count; x++) {
        str += chr;
    };

    return str;
}

// Pad the string on the left with the specified 'pad' character, to get it up to the width specified
String.prototype.padL = function (width, pad) {
    if (!width || width < 1)
        return this;

    if (!pad) pad = " ";
    var length = width - this.length
    if (length < 1) return this.substr(0, width);

    return (String.repeat(pad, length) + this).substr(0, width);
}

String.prototype.padR = function (width, pad) {
    if (!width || width < 1)
        return this;

    if (!pad) pad = " ";
    var length = width - this.length
    if (length < 1) this.substr(0, width);

    return (this + String.repeat(pad, length)).substr(0, width);
}

// Format a date object based on a given format string
// Note: Including "Z" in format string returns UTC time, but "Z" is left in the string!
Date.prototype.formatDate = function (format) {
    var date = this;
    if (!format)
        format = "MM/dd/yyyy";

    var month = date.getMonth() + 1;
    var year = date.getFullYear();

    function getMonthName(month) {
        var month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return month_names_short[month - 1];
    }

    function getFullMonthName(month) {
        var month_names_short = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'];
        return month_names_short[month - 1];
    }

    if (format.indexOf("yyyy") > -1)
        format = format.replace("yyyy", year.toString());
    else if (format.indexOf("yy") > -1)
        format = format.replace("yy", year.toString().substr(2, 2));

    format = format.replace("dd", date.getDate().toString().padL(2, "0"));
    var hours = date.getHours();
    if (format.indexOf("Z") > -1)
        hours = date.getUTCHours();
    if (format.indexOf("t") > -1) {
        if (hours > 11)
            format = format.replace("t", "pm")
        else
            format = format.replace("t", "am")
    }
    if (format.indexOf("HH") > -1)
        format = format.replace("HH", hours.toString().padL(2, "0"));
    if (format.indexOf("hh") > -1) {
        if (hours > 12) hours -= 12;
        if (hours == 0) hours = 12;
        format = format.replace("hh", hours.toString().padL(0, "0"));
    }
    if (format.indexOf("mm") > -1)
        format = format.replace("mm", date.getMinutes().toString().padL(2, "0"));
    if (format.indexOf("ss") > -1)
        format = format.replace("ss", date.getSeconds().toString().padL(2, "0"));
    if (format.indexOf("SSS") > -1)
        format = format.replace("SSS", date.getMilliseconds().toString().padL(3, "0"));

    format = format.replace("MMMM", getFullMonthName(month));
    format = format.replace("MMM", getMonthName(month));
    format = format.replace("MM", month.toString().padL(2, "0"));

    return format;
}

// Format a date object based on a given format string
// Includes additional features not in formatDate
// "SFX" -> "rd", "nd", "st, "th"
// "DDD" -> "Mon, "Tue", etc.
// "DDDD" -> "Monday, "Tuesday", etc.
// "d" -> day of the month without padding with "0"s
Date.prototype.formatDateEnhanced = function (format) {
    var date = this;

    function getDayName(day) {
        var day_names_short = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        return day_names_short[day];
    }

    function getFullDayName(day) {
        var day_names_short = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return day_names_short[day];
    }

    function getDateSuffix(selectedDate) {
        switch (selectedDate) {
            case 3:
            case 23:
                return "rd";
            case 2:
            case 22:
                return "nd";
            case 1:
            case 21:
            case 31:
                return "st";
            default:
                return "th";
        }
    }

    format = this.formatDate(format);

    var weekDay = date.getDay();

    format = format.replace("d", date.getDate())

    format = format.replace("SFX", getDateSuffix(date.getDate()));

    format = format.replace("DDDD", getFullDayName(weekDay));

    format = format.replace("DDD", getDayName(weekDay));

    return format;
}

// Add specific number of hours to given time
Date.prototype.addHours = function (h) {
    this.setHours(this.getHours() + h);
    return this;
}

// Utility for adding a method to Function
Function.prototype.method = function (name, func) {
    if (!this.prototype[name]) {
        this.prototype[name] = func;
        return this;
    }
};

// Return the integer part of a number (positive or negative)
Number.method('integer', function () {
    return Math[this < 0 ? 'ceil' : 'floor'](this);
});

//var InterfaceTypes = { "Exchange": 1, "Sportsbook": 2, "Pool": 3, "Tote": 4 };
window.ModeTypes = { "Singles": 1, "Multiples": 2, "Sportsbook": 3 };
window.PriceFormatTypes = { "Decimal": 1, "Fractional": 2, "American": 3 };
//var WalletTypes = { "SinglePurse": 1, "FundsTransfer": 2 };
//var PunterTypes = { "GIS": 1, "Native": 2 };

function dateFromISO8601(isostr) {
    var parts = isostr.match(/\d+/g);
    if (parts[0] == "0001") return null;
    var month = parts[1] - 1;
    var hour = parts[3] - parts[6];
    return new Date(parts[0], month, parts[2], parts[3], parts[4], parts[5]);
}

function isLeapYear(year) {

    return (year % 400 == 0) || ((year % 4 == 0) && (year % 100 != 0));
}

function goUrl(url, width, height, new_win, name, resize, scroll, menu) {

    if (new_win == "Y") {
        if (resize == "N") {
            resize = "no";
        } else {
            resize = "yes";
        }
        if (scroll == "N") {
            scroll = "no";
        } else {
            scroll = "yes";
        }
        if (menu == "Y") {
            menu = "yes";
        } else {
            menu = "no";
        }
        var dimensions = "";
        if (width != "") {
            dimensions += ",width=" + width;
        }
        if (height != "") {
            dimensions += ",height=" + height;
        }
        if (name == "") {
            name == "helpwin";
        }
        var newWindow = window.open(url, name, "scrollbars=" + scroll + ",resizable=" + resize + ",menubar=" + menu + dimensions);
        newWindow.focus();
    } else {
        document.location.href = url;
    }

}
//get querystring parameter
function qs(key) {
    key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
    var match = location.search.match(new RegExp("[?&]" + key + "=([^&]+)(&|$)", 'i'));
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

// Add com to Jest global object so it can be accessed when running Jest automated tests
if (typeof global !== "undefined") {
    global.com = com;
}